import { get } from "lodash";
import type { TRootStore } from "../../types";

export const getAflIdModalStatus = (
	state: TRootStore
) => get(state, "aflIdModal.currentAFLiDModal");